import { FETCH_STAFF } from '../../actionTypes/shared/apiActionTypes';
import parseStaffResponse from './staffParsers';

export const initialState = {
    data: {},
    error: null,
    isStaffFetching: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_STAFF.START:
            return {
                ...state,
                isStaffFetching: true,
            };
        case FETCH_STAFF.SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...parseStaffResponse(action.response),
                },
                isStaffFetching: false,
            };
        case FETCH_STAFF.ERROR:
            return { ...state, isStaffFetching: false, error: action.error };
        default:
            return state;
    }
};

const getStaff = state => state.data;
const getStaffById = (state, id) => getStaff(state)[id];
const isStaffFetching = state => state.isStaffFetching;
const getStaffByIds = (state, ids) => ids.map(id => getStaffById(state, id));

export const selectors = {
    getStaff,
    getStaffById,
    getStaffByIds,
    isStaffFetching,
};
